import React from "react";
import { Typography, Grid } from "@mui/material";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css"; // Import styles for zoom

const galleryImages = [
  { src: "/images/gallery/hr1.jpg", alt: "Image 1" },
  { src: "/images/gallery/hr2.jpg", alt: "Image 2" },
  { src: "/images/gallery/hr3.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr4.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr5.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr6.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr7.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr8.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr9.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr10.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr11.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr12.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr13.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr14.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr15.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr16.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr17.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr18.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr19.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr20.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr21.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr22.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr23.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr24.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr25.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr26.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr27.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr28.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr29.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr30.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr31.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr32.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr33.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr34.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr35.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr36.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr37.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr38.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr39.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr40.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr41.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr42.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr43.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr44.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr45.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr46.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr47.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr48.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr49.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr50.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr51.jpg", alt: "Image 3" },
  { src: "/images/gallery/hr52.jpg", alt: "Image 3" },
  // Add more images here
];

const WinningHistory = () => {
  return (
    <div>
      <Typography variant="h4" color="gery" gutterBottom>
        Winning History
      </Typography>

      <Grid container spacing={2}>
        {galleryImages.map((image, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Zoom>
              <img
                src={image.src}
                alt={image.alt}
                style={{
                  width: "100%",
                  height: "auto",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              />
            </Zoom>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default WinningHistory;
